import MultidietCtaBg from "@/assets/images/multidiet-cta.png";
import { MultidietCtaButton } from "@/features/static-builder/components/multidiet-cta/multidiet-cta-button";
import { interpretColors } from "@/lib/helpers/typography";
import type { MultidietCTAListingType } from "../../types/multidiet-cta.type";

export const MultidietCTAListing = ({
  data,
}: {
  data: MultidietCTAListingType | null;
}) => {
  if (!data || !data.buttonLabel) return null;
  return (
    <div
      className="flex h-full flex-col rounded-lg bg-brand-grey1 bg-position-[right_center] bg-size-[80px_auto] p-6 pr-30 max-lg:justify-center md:bg-position-[right_56px_center] lg:flex-row xl:gap-8 xl:bg-size-[175px_auto] xl:px-8 xl:py-10"
      data-pw="multidiet-banner"
      style={{
        backgroundImage: `url(${MultidietCtaBg.src})`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="flex flex-col gap-0 text-left md:gap-4 xl:w-2/3">
        {data.title && (
          <h2
            className="font-medium text-xl sm:text-2xl md:text-[32px] md:leading-9"
            dangerouslySetInnerHTML={{
              __html: interpretColors(data.title),
            }}
          />
        )}
        {data.subtitle && (
          <div
            className="font-medium text-xl"
            dangerouslySetInnerHTML={{
              __html: interpretColors(data.subtitle),
            }}
          />
        )}
        <div className="mt-3 md:mt-6 lg:mt-0">
          <MultidietCtaButton
            buttonLabel={data.buttonLabel}
            testId="multidiet-banner-button"
          />
        </div>
      </div>
    </div>
  );
};
